import React, { useState } from "react";
import axios from "axios";
import "./Login.css";

function Login({ setToken }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const login = async (e) => {
    e.preventDefault(); // prevent page reload on form submit
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/users/login`,
        { username, password }
      );
      setToken(response.data.token);
      localStorage.setItem("token", response.data.token);
    } catch (err) {
      alert("Login failed: " + err);
    }
  };

  return (
    <div className="login-container">
      <h2 className="text-xl font-bold mb-4">Login</h2>
      <form className="login-box" onSubmit={login}>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          className="border p-2 mr-2"
          required
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="border p-2 mr-2"
          required
        />
        <button type="submit" className="bg-green-500 text-white px-4 py-2">
          Login
        </button>
      </form>
    </div>
  );
}

export default Login;
